var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrderCancelledIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151,
    height: 150,
    viewBox: "0 0 151 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13637_8990)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150,
    transform: "translate(0.5)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.176 27.6777C39.176 25.6464 40.814 24 42.8345 24H97.1899C99.2104 24 100.848 25.6464 100.848 27.6777C100.848 29.7089 99.2104 31.3553 97.1899 31.3553H85.6916C83.6711 31.3553 82.0331 33.0018 82.0331 35.033C82.0331 37.0642 83.6711 38.7107 85.6916 38.7107H112.347C114.945 38.7107 117.051 40.8276 117.051 43.4391C117.051 46.0506 114.945 48.1675 112.347 48.1675H30.2909C27.6931 48.1675 25.5871 46.0506 25.5871 43.4391C25.5871 40.8276 27.6931 38.7107 30.2909 38.7107H52.7648C52.3045 38.7107 51.864 38.6252 51.4582 38.4693C52.8335 37.9405 53.8101 36.6014 53.8101 35.033C53.8101 33.4645 52.8335 32.1254 51.4582 31.5967C51.864 31.4408 52.3045 31.3553 52.7648 31.3553H42.8345C40.814 31.3553 39.176 29.7089 39.176 27.6777Z",
    fill: "#F6F8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.141 43.4391C119.141 40.8276 121.247 38.7107 123.845 38.7107H133.253C135.85 38.7107 137.956 40.8276 137.956 43.4391C137.956 46.0506 135.85 48.1675 133.253 48.1675H123.845C121.247 48.1675 119.141 46.0506 119.141 43.4391Z",
    fill: "#F6F8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2909 55.5228C27.6931 55.5228 25.5871 57.6398 25.5871 60.2513C25.5871 62.8628 27.6931 64.9797 30.2909 64.9797H94.5767C97.1745 64.9797 99.2805 62.8628 99.2805 60.2513C99.2805 57.6398 97.1745 55.5228 94.5767 55.5228H30.2909Z",
    fill: "#F6F8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.72648 76.2754C5.72648 74.0992 7.48145 72.335 9.64634 72.335H41.5279C43.6928 72.335 45.4477 74.0992 45.4477 76.2754C45.4477 78.4516 43.6928 80.2157 41.5279 80.2157H39.9599C37.795 80.2157 36.0401 81.9799 36.0401 84.1561C36.0401 86.3323 37.795 88.0965 39.9599 88.0965H65.047C62.8822 88.0965 61.1272 86.3323 61.1272 84.1561C61.1272 81.9799 62.8822 80.2157 65.047 80.2157H124.106C126.271 80.2157 128.026 81.9799 128.026 84.1561C128.026 86.3323 126.271 88.0965 124.106 88.0965H113.392C111.227 88.0965 109.472 89.8606 109.472 92.0368C109.472 94.213 111.227 95.9772 113.392 95.9772H119.402C121.567 95.9772 123.322 97.7413 123.322 99.9175C123.322 102.094 121.567 103.858 119.402 103.858H95.3606C97.5255 103.858 99.2805 105.622 99.2805 107.798C99.2805 109.974 97.5255 111.739 95.3606 111.739H64.5244C62.3595 111.739 60.6045 113.503 60.6045 115.679C60.6045 117.855 62.3595 119.619 64.5244 119.619H69.2282C71.3931 119.619 73.1481 121.383 73.1481 123.56C73.1481 125.736 71.3931 127.5 69.2282 127.5H36.824C34.6592 127.5 32.9042 125.736 32.9042 123.56C32.9042 121.383 34.6592 119.619 36.824 119.619H37.3467C39.5116 119.619 41.2666 117.855 41.2666 115.679C41.2666 113.503 39.5116 111.739 37.3467 111.739H4.41986C2.25497 111.739 0.5 109.974 0.5 107.798C0.5 105.622 2.25497 103.858 4.41986 103.858H20.0993C17.9344 103.858 16.1794 102.094 16.1794 99.9175C16.1794 97.7413 17.9344 95.9772 20.0993 95.9772H20.8833C23.0482 95.9772 24.8031 94.213 24.8031 92.0368C24.8031 89.8606 23.0482 88.0965 20.8833 88.0965H19.054C16.8891 88.0965 15.1341 86.3323 15.1341 84.1561C15.1341 81.9799 16.8891 80.2157 19.054 80.2157H9.64634C7.48145 80.2157 5.72648 78.4516 5.72648 76.2754Z",
    fill: "#F6F8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.65 80.2157C134.485 80.2157 132.73 81.9799 132.73 84.1561C132.73 86.3323 134.485 88.0965 136.65 88.0965H146.58C148.745 88.0965 150.5 86.3323 150.5 84.1561C150.5 81.9799 148.745 80.2157 146.58 80.2157H136.65Z",
    fill: "#F6F8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.0087 113.315C91.2768 113.315 89.8728 114.726 89.8728 116.467C89.8728 118.208 91.2768 119.619 93.0087 119.619H99.8031C101.535 119.619 102.939 118.208 102.939 116.467C102.939 114.726 101.535 113.315 99.8031 113.315H93.0087Z",
    fill: "#F6F8FC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 98.4375C10.1746 98.4375 11.9375 96.6746 11.9375 94.5C11.9375 92.3254 10.1746 90.5625 8 90.5625C5.82538 90.5625 4.0625 92.3254 4.0625 94.5C4.0625 96.6746 5.82538 98.4375 8 98.4375ZM8 99.75C10.8995 99.75 13.25 97.3995 13.25 94.5C13.25 91.6005 10.8995 89.25 8 89.25C5.10051 89.25 2.75 91.6005 2.75 94.5C2.75 97.3995 5.10051 99.75 8 99.75Z",
    fill: "#D2D9E7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.5 31.875C135.607 31.875 138.125 29.3566 138.125 26.25C138.125 23.1434 135.607 20.625 132.5 20.625C129.393 20.625 126.875 23.1434 126.875 26.25C126.875 29.3566 129.393 31.875 132.5 31.875ZM132.5 33.75C136.642 33.75 140 30.3921 140 26.25C140 22.1079 136.642 18.75 132.5 18.75C128.358 18.75 125 22.1079 125 26.25C125 30.3921 128.358 33.75 132.5 33.75Z",
    fill: "#D2D9E7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.5408,
    cy: 65.0408,
    r: 2.04082,
    fill: "#EEF2F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 112.235,
    cy: 109.444,
    r: 2.04082,
    fill: "#EEF2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.809 110.566C128.809 109.977 129.286 109.5 129.875 109.5C130.464 109.5 130.941 109.977 130.941 110.566V116.961C130.941 117.549 130.464 118.026 129.875 118.026C129.286 118.026 128.809 117.549 128.809 116.961V110.566Z",
    fill: "#D2D9E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.809 122.289C128.809 121.701 129.286 121.224 129.875 121.224C130.464 121.224 130.941 121.701 130.941 122.289V128.684C130.941 129.273 130.464 129.75 129.875 129.75C129.286 129.75 128.809 129.273 128.809 128.684V122.289Z",
    fill: "#D2D9E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.934 118.559C139.523 118.559 140 119.036 140 119.625C140 120.214 139.523 120.691 138.934 120.691H132.539C131.951 120.691 131.474 120.214 131.474 119.625C131.474 119.036 131.951 118.559 132.539 118.559H138.934Z",
    fill: "#D2D9E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.211 118.559C127.799 118.559 128.276 119.036 128.276 119.625C128.276 120.214 127.799 120.691 127.211 120.691H120.816C120.227 120.691 119.75 120.214 119.75 119.625C119.75 119.036 120.227 118.559 120.816 118.559H127.211Z",
    fill: "#D2D9E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.56 59.6773C137.759 59.4781 138.083 59.478 138.282 59.6773C138.481 59.8766 138.481 60.1996 138.282 60.3988L136.117 62.5635C135.918 62.7627 135.595 62.7627 135.396 62.5635C135.196 62.3642 135.196 62.0411 135.396 61.8419L137.56 59.6773Z",
    fill: "#D2D9E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.592 63.6458C133.791 63.4465 134.114 63.4465 134.313 63.6458C134.513 63.845 134.513 64.1681 134.313 64.3673L132.149 66.5319C131.949 66.7311 131.626 66.7312 131.427 66.5319C131.228 66.3327 131.228 66.0096 131.427 65.8104L133.592 63.6458Z",
    fill: "#D2D9E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.282 65.8104C138.481 66.0096 138.481 66.3327 138.282 66.5319C138.083 66.7311 137.76 66.7312 137.56 66.5319L135.396 64.3673C135.196 64.168 135.196 63.845 135.396 63.6458C135.595 63.4465 135.918 63.4465 136.117 63.6458L138.282 65.8104Z",
    fill: "#D2D9E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.313 61.8419C134.513 62.0412 134.513 62.3642 134.313 62.5635C134.114 62.7627 133.791 62.7627 133.592 62.5635L131.427 60.3988C131.228 60.1996 131.228 59.8765 131.427 59.6773C131.626 59.4781 131.949 59.478 132.149 59.6773L134.313 61.8419Z",
    fill: "#D2D9E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4605 20.2105C24.8965 20.2105 25.25 20.564 25.25 21C25.25 21.436 24.8965 21.7895 24.4605 21.7895L19.7237 21.7895C19.2877 21.7895 18.9342 21.436 18.9342 21C18.9342 20.564 19.2877 20.2105 19.7237 20.2105L24.4605 20.2105Z",
    fill: "#D2D9E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7763 20.2105C16.2123 20.2105 16.5658 20.564 16.5658 21C16.5658 21.436 16.2123 21.7895 15.7763 21.7895L11.0395 21.7895C10.6035 21.7895 10.25 21.436 10.25 21C10.25 20.564 10.6035 20.2105 11.0395 20.2105L15.7763 20.2105Z",
    fill: "#D2D9E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5395 27.7105C18.5395 28.1466 18.186 28.5 17.75 28.5C17.314 28.5 16.9605 28.1466 16.9605 27.7105L16.9605 22.9737C16.9605 22.5377 17.314 22.1842 17.75 22.1842C18.186 22.1842 18.5395 22.5377 18.5395 22.9737L18.5395 27.7105Z",
    fill: "#D2D9E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5395 19.0263C18.5395 19.4623 18.186 19.8158 17.75 19.8158C17.314 19.8158 16.9605 19.4623 16.9605 19.0263L16.9605 14.2895C16.9605 13.8534 17.314 13.5 17.75 13.5C18.186 13.5 18.5395 13.8534 18.5395 14.2895L18.5395 19.0263Z",
    fill: "#D2D9E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.219 35.1992C95.219 32.4372 92.9828 30.1982 90.2243 30.1982H32.2857C29.5272 30.1982 27.291 32.4372 27.291 35.1992L27.291 112.062C27.291 113.176 27.6628 114.259 28.3474 115.137L31.1763 118.769C31.6762 119.41 32.6455 119.41 33.1454 118.769L37.0307 113.781L40.9159 118.769C41.4159 119.41 42.3852 119.41 42.8851 118.769L46.7704 113.781L50.6556 118.769C51.1556 119.41 52.1249 119.41 52.6248 118.769L56.5101 113.781L60.2609 118.723C60.7606 119.381 61.7495 119.381 62.2492 118.723L66 113.781L69.8853 118.769C70.3852 119.41 71.3545 119.41 71.8544 118.769L75.7397 113.781L79.6249 118.769C80.1249 119.41 81.0942 119.41 81.5941 118.769L85.4794 113.781L89.3646 118.769C89.8645 119.41 90.8339 119.41 91.3338 118.769L94.1627 115.137C94.8472 114.259 95.219 113.176 95.219 112.062V35.1992Z",
    fill: "url(#paint0_linear_13637_8990)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.3359,
    y: 89.0757,
    width: 41.25,
    height: 6,
    rx: 3,
    fill: "white",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.3359,
    y: 69.5757,
    width: 41.25,
    height: 5.25,
    rx: 2.625,
    fill: "white",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.3359,
    y: 50.0757,
    width: 41.25,
    height: 5.25,
    rx: 2.625,
    fill: "white",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 95.185,
    cy: 74.8403,
    r: 28.3403,
    fill: "url(#paint1_linear_13637_8990)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.07 61.8879C106.289 61.1068 105.023 61.1068 104.242 61.8879L95.1856 70.9443L86.1291 61.8878C85.348 61.1068 84.0817 61.1068 83.3006 61.8878L82.233 62.9555C81.4519 63.7365 81.4519 65.0029 82.233 65.7839L91.2895 74.8404L82.2329 83.897C81.4519 84.678 81.4519 85.9443 82.2329 86.7254L83.3006 87.7931C84.0816 88.5741 85.348 88.5741 86.129 87.7931L95.1856 78.7365L104.242 87.793C105.023 88.5741 106.289 88.5741 107.071 87.793L108.138 86.7254C108.919 85.9443 108.919 84.678 108.138 83.897L99.0816 74.8404L108.138 65.7839C108.919 65.0029 108.919 63.7366 108.138 62.9555L107.07 61.8879Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13637_8990",
    x1: 61.4033,
    y1: 122.45,
    x2: 88.3566,
    y2: 21.5074,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9D2E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBF1FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_13637_8990",
    x1: 66.8447,
    y1: 50.2787,
    x2: 123.525,
    y2: 111.683,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5535D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF979D"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13637_8990"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderCancelledIcon);
export default __webpack_public_path__ + "static/media/order-cancelled-icon.a99049aba5d02dc67cba96c4ec077cd1.svg";
export { ForwardRef as ReactComponent };